import { isProd } from "src/utilities/isProd";
import getQueryParamValue from "src/utilities/getQueryParamValue";

export const getSierraInstance = () => {
  const sierraInstance = isProd()
    ? "fExxgdUBmA_XivcBmA_XizPvI6pWqIx8oPgqSmuZaOo"
    : "TDp2Fo8BmA_XivcBmIkLrMjvI6pWqIx8oPgq9DhwmO4";

  const domain = getQueryParamValue("sierra-staging")
    ? "https://eu.staging.sierra.chat"
    : "https://eu.sierra.chat";

  const target = getQueryParamValue("sierraTarget");
  const validTargetRegex = /^[a-zA-Z0-9_:/-]+$/;
  const targetPath =
    target && validTargetRegex.test(target) ? `/${target}` : "";

  return `${domain}/agent/${sierraInstance}/embed${targetPath}`;
};
